export default __webpack_public_path__ + "static/media/options-icon.a76c1afb.svg";